import { StoreType } from 'store/root';
import { IToast } from 'utils/types';

export const getToastListSelector = (store: StoreType): IToast[] => {
	return store.toastifyStore.toastList;
};
